import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { JsonApiProcessor, OperationServiceAdapter } from '../operation'
import { ExpirationMessage } from '../../models'

@Injectable()
export class ExpirationMessageService extends OperationServiceAdapter<any> {

  constructor(
    _processor: JsonApiProcessor
  ) {
    super(_processor, ExpirationMessage)
  }

  public getExpirationMessage(): Observable<ExpirationMessage> {
    return this.callGetOperation('message').catch(() => {
      const emptyMsg = new ExpirationMessage()
      emptyMsg.id = ''
      emptyMsg.message = ''
      return Observable.of(emptyMsg)
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/expiration-message/expiration-message.service.ts